module.exports = __webpack_public_path__ + "static/locations-hero-5c73f7e379e6837dbb643b20684deb6a.svg";